import React, { useEffect, useState} from 'react';
import DataTable from 'react-data-table-component';
import Card from '../card.component';
import Modal from '../modal/modal.component';
import 'react-data-table-component-extensions/dist/index.css';
import functions from '../../views/facturacion/facturacion.functions';
import LoaderWindow from '../loaderWindow.component';
import DataTableExtensions from 'react-data-table-component-extensions';
import utils from '../../utils/utils.functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      }
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
};

export default function SalesModal({ visible, onSelectItem, close, initialTypeDocument }) {

 const [data, setData] = useState([]);
 const [load, setLoad] = useState(true);

 useEffect(() => {
    functions.listado(initialTypeDocument).then((response) => {
      setData(response);
      setLoad(false);
    });
 },[]);

 const itemSelected = (item) => {
    onSelectItem(item);
 }

 const columns = [
    {
        name: 'Recibo Nro.',
        selector: 'id',
        sortable: true,
        wrap: true,
    },
    {
      name: 'Cliente',
      selector: row => row.boleta_cliente.name,
      sortable: true,
      wrap: true,
      cell: row => row.boleta_cliente.name,
    },
    {
      name: 'Venta',
      selector: row => row.boleta_guia ? `GUIA ${row.boleta_guia.prefijo_guia}-${row.boleta_guia.guia_paquete}` : 'PRODUCTOS',
      sortable: true,
      right: true,
    },
    {
        name: 'Pago',
        selector: 'monto_total',
        sortable: true,
        right: true,
        cell: row => utils.formatMoney(row.monto_total),
    },
    {
      name: 'Seleccionar',
      sortable: false,
      right: true,
      cell: row => (
        <button 
          onClick={() => itemSelected(row)}
          type="button"
          className="btnx btnx-warn m-1"
        >
            <FontAwesomeIcon icon={faCheck} />
        </button>
      )
    },
  ];

 return (
    <Modal show={visible} backDrop={true}>
        <Card>
            {load ? 
                <LoaderWindow />
            : 
                <DataTableExtensions
                    columns={columns}
                    data={data}
                    export={false}
                    print={false}
                    filterPlaceholder="Buscar recibo de pago."
                >
                    <DataTable
                        noHeader={true}
                        customStyles={customStyles}
                        dense={true}
                        pagination={true}
                        paginationPerPage={5}
                        noDataComponent={"No existen datos asociados a la busqueda."}
                    />
                </DataTableExtensions>
            }
            <div className="row">
                <div className="col-12">
                    <button 
                        onClick={() => close()}
                        type="button"
                        className="btnx btnx-warn mr-1"
                        >
                            Cerrar
                    </button>
                </div>
            </div>
        </Card>
    </Modal>
  )
}
